module.exports = __webpack_public_path__ + "static/media/samsung_dark.bc334aaf.png";